var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 20.1",
    style: {
      enableBackground: "new 0 0 21 20.1"
    },
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8,5.1l-4.6-4.8c-0.3-0.3-0.7-0.3-1,0L3.5,10.6c-0.1,0.1-0.2,0.2-0.2,0.3L2,14.3l0,0l0,0.1l-0.3,0.7l0,0 L0,20.1l5.7-1.8l0,0L9.2,17c0.1,0,0.2-0.1,0.3-0.2L20.8,6.1C20.9,6,21,5.8,21,5.6S20.9,5.2,20.8,5.1z M3.2,15.5l1.3-3.4l3.3,3.8 L4.6,17L3.2,15.5z M9,15.1l-3.6-4.2l10.3-9.1l3.5,3.7L9,15.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.3eb849dabb0bd6bace6faaa0e6131a22.svg";
export { ForwardRef as ReactComponent };